import apiClient from '../axiosInstance';
import { API_BASE_ADDRESS } from '../api';

import { getMemberTransferAction } from '../sagas/recess/memberTransferStatusSaga';
// 会員管理側会員移籍状態を取得します。
const memberTransferStatusService = (action: getMemberTransferAction): any => {
  return {
    getMemberTransferStatus: () =>
      apiClient.get(`${API_BASE_ADDRESS}/mypage/member/${action.memberNo}/non-kiosk-transfer/status`),
  };
};

export default memberTransferStatusService;
